import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: React.ReactNode;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  title: '知识管理平台',
  pwa: true,
  logo: false,
  token: {
    // bgLayout: 'rgb(1, 54, 174)',
    colorPrimary: '#5CB85C',
    bgLayout: '#eeeeee',
    // bgLayout: '#f0f0f0',
    header: {
      colorBgHeader: '#1A73E8',
      colorHeaderTitle: 'rgb(255, 255, 255)',
      colorTextMenu: 'rgb(255, 255, 255)',
      colorTextMenuActive: 'rgb(255, 255, 255)',
      colorTextMenuSelected: 'rgb(255, 255, 255)',
      colorTextMenuSecondary: 'rgb(255, 255, 255)',
      colorTextRightActionsItem: 'rgb(255, 255, 255)',
      heightLayoutHeader: 50,
    },
    pageContainer: {
      // colorBgPageContainer: 'rgb(255, 255, 255)',
      colorBgPageContainer: '#eeeeee',
      marginInlinePageContainerContent: 0,
      marginBlockPageContainerContent: 0,
      paddingInlinePageContainerContent: 20,
      paddingBlockPageContainerContent: 20,
    },
    sider: {
      colorMenuBackground: '#ffffff',
    },
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  iconfontUrl: '',
  splitMenus: true,
  siderMenuType: 'group',
  footerRender: false,
};

export default Settings;
